export type SystemItem = {
  number: string
  title: string
  lead: string
  body: string[]
  price: string
}

export const systems: SystemItem[] = [
  {
    number: '01',
    title: 'Installa la Tua Attività di Riparazioni',
    lead: 'Smetti di lavorare come un dilettante e costruisci le basi di un’attività tecnica professionale fin dal primo giorno.',
    body: [
      'Organizza la struttura della tua attività, definisci i processi ed evita gli errori che rallentano la crescita.',
    ],
    price: '97 €',
  },
  {
    number: '02',
    title: 'Fatti Pagare Come un Tecnico Premium',
    lead: 'Uno degli errori più grandi è far pagare “quello che sembra giusto”.',
    body: [
      'Impara a calcolare prezzi redditizi considerando i tuoi costi, il tuo tempo e il tuo profitto, per smettere di regalare il tuo lavoro.',
    ],
    price: '67 €',
  },
  {
    number: '03',
    title: 'Riparazioni Senza Caos',
    lead: 'Implementa un flusso di lavoro chiaro dal momento in cui ricevi l’elettrodomestico fino alla consegna.',
    body: ['Meno errori. Meno lavori rifatti.', 'Più velocità, più organizzazione, più fiducia.'],
    price: '67 €',
  },
  {
    number: '04',
    title: 'Clienti Che Ti Raccomandano',
    lead: 'Una riparazione non dovrebbe finire quando consegni l’elettrodomestico.',
    body: [
      'Crea un’esperienza che aumenti la probabilità che il cliente torni e ti raccomandi.',
    ],
    price: '47 €',
  },
  {
    number: '05',
    title: 'Clienti Ogni Mese',
    lead: 'Strategie semplici per mantenere un flusso costante di opportunità.',
    body: [
      'WhatsApp, TikTok e raccomandazioni locali, senza dipendere esclusivamente dal passaparola.',
    ],
    price: '67 €',
  },
  {
    number: '06',
    title: 'Attività Pronta a Operare',
    lead: 'Il cuore del sistema.',
    body: [
      'Più di 300 documenti, modelli, contratti, ordini di servizio, garanzie, inventari, checklist e formati professionali pronti per essere modificati, stampati e utilizzati oggi.',
    ],
    price: '97 €',
  },
]
